module.exports = __webpack_public_path__ + "img/slider_4.2e78e22a.jpg";